"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.serializeValue = exports.useEditorFooter = void 0;
var lodash_1 = require("lodash");
var react_1 = require("react");
var slate_react_1 = require("slate-react");
var Editor_logic_1 = require("../Editor.logic");
var Editor_static_1 = require("../Editor.static");
var EditorFooter_static_1 = require("./EditorFooter.static");
var EditorFooter_style_1 = __importDefault(require("./EditorFooter.style"));
function useEditorFooter(_a) {
    var initialState = _a.initialState, onDiscard = _a.onDiscard, onSave = _a.onSave, saving = _a.saving, setEditorKey = _a.setEditorKey, setEditorRef = _a.setEditorRef, setState = _a.setState, state = _a.state;
    var isFocused = (0, slate_react_1.useFocused)();
    var isPristine = (0, react_1.useMemo)(function () { return (0, lodash_1.isEqual)(state, (0, Editor_static_1.withEmptyStateFallback)(initialState)); }, [state, initialState]);
    var isDisabled = isPristine || saving;
    var hasUnsavedContent = !isPristine || saving;
    var reInitializeEditor = (0, react_1.useCallback)(function (state) {
        setState((0, Editor_static_1.withEmptyStateFallback)(state));
        setEditorKey((0, lodash_1.uniqueId)('editor'));
    }, [setEditorKey, setState]);
    (0, react_1.useEffect)(function () {
        setEditorRef({
            isFocused: isFocused,
            hasUnsavedContent: hasUnsavedContent,
            reInitializeEditor: reInitializeEditor,
        });
    }, [hasUnsavedContent, isFocused, reInitializeEditor, setEditorRef]);
    var handleSave = function () {
        if (isDisabled) {
            return;
        }
        void onSave({ state: state, isEmpty: !serializeValue(state) });
    };
    var handleDiscard = function () {
        if (isDisabled) {
            return;
        }
        onDiscard ? void onDiscard({ state: state, isEmpty: !serializeValue(state) }) : reInitializeEditor(initialState);
    };
    (0, Editor_logic_1.useEditorHotkeys)({
        'mod+s': isDisabled ? lodash_1.noop : handleSave,
    });
    return {
        classes: (0, EditorFooter_style_1.default)(),
        isDisabled: isDisabled,
        discardProps: {
            onClick: handleDiscard,
        },
        saveProps: {
            onClick: handleSave,
            tooltip: EditorFooter_static_1.localText.tooltipSave,
        },
    };
}
exports.useEditorFooter = useEditorFooter;
function serializeValue(value) {
    return value
        .map(function (node) {
        if ('text' in node) {
            return node.text.trim();
        }
        return node.children ? serializeValue(node.children) : '';
    })
        .join('');
}
exports.serializeValue = serializeValue;
